export class APIResponse<DataType, ErrorType> {
  data: DataType;
  errors: ErrorType;
  success: boolean;
}

export class Pagination<DataType> {
  current_page: number;
  data: DataType;
  from: number;
  last_page: number;
  per_page: number;
  to: number;
  total: number;
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/models/response.ts